import React, { Component } from 'react';
import { Switch, Route } from "react-router-dom";
import { Container } from "semantic-ui-react";

import { privateRoutes } from "../utils/routes";
import request from "../utils/request";
import TopNav from "../components/TopNav";
import SideNav from "../components/SideNav";

const resetUser = () => {
    return {
        email: "",
        fax_number: "",
        first_name: "",
        id: "",
        last_name: "",
        nonprofit_id: "",
        role: "",
        superadmin: "",
        username: ""
    }
}

class PrivateRoute extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSidebar: true,
            user: resetUser()
        };
        this.signOut = this.signOut.bind(this);
        this.handleSidebar = this.handleSidebar.bind(this);
    }

    async componentDidMount() {
        const user = await request.get(this, "api:/user", {});
        this.setState({ user: user });
    }

    signOut() {
        const queryParams = new URLSearchParams(window.location.search);
        const { cookies } = this.props;

        if (queryParams.get('access_token')) this.props.history.push("/");

        cookies.remove("accessToken", { path: '/' });
        cookies.remove("refreshToken", { path: '/' });

        this.setState({ user: resetUser() });
    };

    handleSidebar() {
        this.setState({ showSidebar: !this.state.showSidebar });
    };

    render() {
        const { showSidebar, user } = this.state;
        const { history, config, settings } = this.props;
        return (
            <Switch>
                {privateRoutes.map((route, index) => (
                    <Route
                        key={`route-${index}`}
                        name={route.name}
                        path={route.path}
                        exact={route.exact}
                        render={props => {
                        return (
                            <Container fluid id="wrapper">
                                <TopNav user={user} settings={settings} handleSidebar={this.handleSidebar} signOut={this.signOut} />
                                <SideNav shown={showSidebar} location={history.location} config={config} />
                                <route.component
                                    {...props}
                                    route={route}
                                    routes={route.routes}
                                    cookies={route.cookies}
                                    breadcrumbs={[]}
                                />
                            </Container>
                        )
                        }}
                    />
                ))}
            </Switch>
        );
    }
}

export default PrivateRoute;

